module.exports = __webpack_public_path__ + "static/img/game15.9a07949.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game15.jpg
// module id = VMP2
// module chunks = 1